import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/oppeningClosingBox';

import ViewBill from './ViewBill';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.oppeningClosingBox,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(ViewBill);
